import { render, staticRenderFns } from "./PriceEV.vue?vue&type=template&id=85f50f84&scoped=true&"
import script from "./PriceEV.vue?vue&type=script&lang=js&"
export * from "./PriceEV.vue?vue&type=script&lang=js&"
import style0 from "./PriceEV.vue?vue&type=style&index=0&id=85f50f84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f50f84",
  null
  
)

export default component.exports